<div toastContainer></div>
<mat-toolbar color="primary" *ngIf="authenticated && currentUser" role="toolbar">
  <div class="flex-row flex xl:gap-x-8 md:gap-4 justify-between px-0 w-full md:px-2" [class.gap-x-0]="searchVisible">
    <div id="logo-title-container" class="flex flex-row justify-start items-center">
      <a [routerLink]="['/']" class="flex flex-row items-center gap-x-4 lg:pr-8">
        <img src="/assets/logo-small.png" alt="HireLogic Logo" class="mr-8 lg:mr-0" />
        <h1 class="hidden lg:block" id="hirelogic-heading">{{ title }}</h1>
      </a>
    </div>
    <div
      class="flex flex-row flex-grow flex-shrink lg:space-x-2 xl:space-x-4 basis-3/5 justify-start items-center hidden lg:flex"
      role="navigation">
      <a mat-flat-button color="primary" [routerLink]="['/dashboard']" id="dashboard">Dashboard</a>
      <a mat-flat-button color="primary" [routerLink]="['/customers']" id="customers">Customers</a>
      <a mat-flat-button color="primary" [routerLink]="['/product']" id="products">Products</a>
      <a mat-flat-button color="primary" [routerLink]="['/reports']">Reports</a>
      <a mat-flat-button color="primary" [routerLink]="['/workshop']">Workshop</a>
    </div>
    <div
      class="flex-shrink xl:flex-grow-0 flex-grow basis-1/4 basis-full justify-items-stretch xl:flex hidden items-center"
      [class.hidden]="!searchVisible" [class.flex]="searchVisible">
      <input id="global-search" class="flex basis-full" placeholder="Search contracts, customers, products & items"
        aria-label="Search" [formControl]="searchInput" [matAutocomplete]="auto" #searchInputElement />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
        @if (noSearchResults | async; as noSearchResults) {
        <mat-option [value]="null">
          <p class="text-center text-sm text-gray-500 italic">No results found</p>
        </mat-option>
        } @else {
        @for (group of searchResults | async; track group.label) {
        <mat-optgroup [label]="group.label">
          @for (result of group.items; track result.id) {
          <mat-option [value]="result">
            <div class="flex flex-row justify-between items-start w-full">
              <div class="flex flex-col justify-start items-start flex-grow w-full basis-full">
                <p>{{ result.name }}</p>
                <p>
                  <small *ngIf="result.subText">{{ result.subText }}</small>
                </p>
              </div>
              <img *ngIf="result.onSage" src="/assets/icons/sage.svg" class="w-auto h-4 flex-shrink ml-4 mt-3" />
            </div>
          </mat-option>
          }
        </mat-optgroup>
        }
        }
      </mat-autocomplete>
      <div class="inline xl:hidden" [class.hidden]="!searchVisible">
        <button mat-icon-button (click)="openScanner()">
          <mat-icon>barcode_reader</mat-icon>
        </button>
        <button mat-icon-button (click)="toggleSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="flex-row justify-start items-center hidden xl:hidden" [class.lg:flex]="!searchVisible">
      <button mat-icon-button (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
      </button>
    </div>

    <!-- Mobile Menu dropdown -->
    <div class="flex-grow flex-shrink basis-full flex-row lg:hidden justify-around items-center"
      [class.flex]="!searchVisible" [class.hidden]="searchVisible">
      <div class="flex flex-shrink-0 flex-grow-0 basis-1/2 justify-center items-center">
        <button mat-icon-button [matMenuTriggerFor]="mainMenu">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <div class="flex flex-shrink-0 flex-grow-0 basis-1/2 justify-center items-center">
        <button mat-icon-button (click)="toggleSearch()">
          <mat-icon>search</mat-icon>
        </button>
      </div>
      <mat-menu #mainMenu="matMenu">
        <button mat-menu-item [routerLink]="['/dashboard']">Dashboard</button>
        <button mat-menu-item [routerLink]="['/customers']">Customers</button>
        <button mat-menu-item [matMenuTriggerFor]="productsMenu">
          Products
        </button>
        <button mat-menu-item [routerLink]="['/reports']">Reports</button>
        <button mat-menu-item [routerLink]="['/workshop']">Workshop</button>
      </mat-menu>
      <mat-menu #productsMenu="matMenu">
        <button mat-menu-item [routerLink]="['/product/list']">
          Hire Products
        </button>
        <button mat-menu-item [routerLink]="['/product/retail/list']">
          Retail Products
        </button>
        <button mat-menu-item [routerLink]="['/product/category/list']">
          Categories
        </button>
        <button mat-menu-item [routerLink]="['/product/stock-adjustments']">
          Stock Adjustments
        </button>
      </mat-menu>
    </div>

    <div class="flex-grow-0 flex-shrink-0 w-auto flex flex-row justify-end items-center flex"
      [class.hidden]="searchVisible" data-cy="user-settings">
      <button mat-icon-button [matMenuTriggerFor]="logoutMenu">
        <mat-icon>account_circle</mat-icon>
      </button>
      <div class="flex-col justify-center items-end hidden lg:flex">
        <p [matMenuTriggerFor]="logoutMenu" class="mt-2 m-1" data-cy="user-name">
          {{ currentUser.name }}
        </p>
        <p (click)="editLocation()" class="text-sm m-1 -mt-2">
          @if (currentLocation$ | async; as currentLocation) {
          {{ currentLocation.name }}
          } @else {
          'No Location Set'
          }
        </p>
      </div>
      <mat-menu #logoutMenu="matMenu" yPosition="below">
        <button mat-menu-item (click)="editLocation()">Set Location</button>
        <button mat-menu-item [routerLink]="['/users']">Users</button>
        <button mat-menu-item [routerLink]="['/settings']">Settings</button>
        <button mat-menu-item [routerLink]="['/epos']">EPOS</button>
        <button mat-menu-item [routerLink]="['/counter']">Counter Sign</button>
        <button mat-menu-item (click)="openUpdateDialog()">About</button>
        <button mat-menu-item (click)="logOut()">Logout</button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>
<div class="flex flex-col flex-grow flex-shrink justify-start items-stretch overflow-y-auto h-full app-bg"
  cdkScrollable>
  <router-outlet></router-outlet>
</div>